import React from 'react';

import { createSvgIcon } from '@mui/material/utils';

const GraphIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
        <path d="M16.8506 15.3034H1.14983C0.524092 15.3034 0.173505 14.5823 0.559984 14.0902L3.76631 10.0074C4.02577 9.67699 4.50596 9.62412 4.83109 9.89013L6.43806 11.2049L9.50893 6.69907C9.76852 6.31817 10.307 6.25938 10.6427 6.5753L12.8356 8.63923L16.2168 3.29563C16.6186 2.66071 17.6006 2.94531 17.6006 3.69666V14.5534C17.6006 14.9676 17.2648 15.3034 16.8506 15.3034Z" />
    </svg>,
    'GraphIcon'
);

export default GraphIcon;
